import Button from "src/components/Button";
import useGet from "src/hooks/rest/useGet";
import useAuth from "src/hooks/selectors/useAuth";
import { useTranslation } from "react-i18next";
import SubscriptionProtectButton from "src/components/subscription/subscription-protect/SubscriptionProtectButton";

interface ChatButtonProps {
	to: string;
	registrationId: any;
	className?: string;
}

const ChatButton = ({ to, registrationId, className }: ChatButtonProps) => {
	const { t } = useTranslation("common");
	const auth = useAuth();
	const [data] = useGet(`/inbox/${registrationId}/unread-count`);
	const { count } = data?.data || {};

	if (auth.type === "company") {
		return (
			<SubscriptionProtectButton
				{...{ className, to }}
				type="dark"
				indicator={count}
			>
				<i className="fas fa-comments mr-2"></i>
				{t("chat")}
			</SubscriptionProtectButton>
		);
	}

	return (
		<Button to={to} type="dark" indicator={count} className={className}>
			<i className="fas fa-comments mr-2"></i>
			{t("chat")}
		</Button>
	);
};

export default ChatButton;
